import React from 'react';

function Fleet() {
  const vehicles = [
    { 
      name: 'Toyota Hiace', 
      seats: '12-15 Seater', 
      features: ['Staff transport', 'Airport transfers', 'Small groups'] 
    },
    { 
      name: 'Toyota Coaster', 
      seats: '22-30 Seater', 
      features: ['Schools', 'Corporate groups', 'City tours'] 
    },
    { 
      name: 'Mitsubishi Rosa', 
      seats: '26-34 Seater', 
      features: ['Tourism', 'Long trips', 'High-roof comfort'] 
    },
    { 
      name: 'School Bus', 
      seats: '30-60 Seater', 
      features: ['CCTV cameras', 'Stop arm system', 'Safety sensors'] 
    },
    { 
      name: 'Luxury Coach', 
      seats: '35-50 Seater', 
      features: ['Recliner seats', 'Entertainment', 'VIP comfort'] 
    }
  ];

  return (
    <section id="fleet" className="fleet-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Our Fleet</h2>
          <p className="section-subtitle">
            Modern, safe, and comfortable vehicles for every journey
          </p>
        </div>
        <div className="row">
          {vehicles.map((vehicle, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 mb-4">
              <div className="fleet-card">
                <div className="fleet-card-header">
                  <h4>{vehicle.name}</h4>
                  <p className="fleet-seats">{vehicle.seats}</p>
                </div>
                <div className="fleet-card-body">
                  <h6>Perfect For:</h6>
                  {vehicle.features.map((feature, i) => (
                    <span key={i} className="feature-badge">{feature}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Fleet;